import { render, staticRenderFns } from "./TablaCalendar.vue?vue&type=template&id=848f07a2&scoped=true"
import script from "./TablaCalendar.vue?vue&type=script&lang=js"
export * from "./TablaCalendar.vue?vue&type=script&lang=js"
import style0 from "./TablaCalendar.vue?vue&type=style&index=0&id=848f07a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848f07a2",
  null
  
)

export default component.exports